<template>
    <div class="main">
        <div class="daohang">
            <el-menu active-text-color="#ffd04b" background-color="#3d5a47" class="el-menu-vertical-demo"
                text-color="#fff" :default-openeds="['1', '2']" :default-active="$route.path" router>
                <el-sub-menu index="1">
                    <template #title>
                        <el-icon><location /></el-icon>
                        <span>韶小助管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/sxz/index-lunbo">首页轮播</el-menu-item>
                        <el-menu-item index="/sxz/users">小程序用户</el-menu-item>
                        <el-menu-item index="/sxz/jianzhi">兼职帖子</el-menu-item>
                        <el-menu-item index="/sxz/jianzhi-pictures">兼职图片</el-menu-item>
                        <el-menu-item index="/sxz/news">系统消息</el-menu-item>
                        <el-menu-item index="/sxz/comment">兼职评论</el-menu-item>
                        <el-menu-item index="/sxz/favorite">兼职收藏</el-menu-item>
                        <el-menu-item index="/sxz/text-sec-check">文本检测管理</el-menu-item>
                        <el-menu-item index="/sxz/media-sec-check">多媒体检测管理</el-menu-item>
                        <el-menu-item index="/sxz/button-switch">按钮开关</el-menu-item>
                        <el-menu-item index="/sxz/jianzhi-top-order">兼职置顶订单</el-menu-item>
                        <el-menu-item index="/sxz/top-plan-config">置顶付费配置</el-menu-item>
                        <el-menu-item index="/sxz/pay-order">支付订单</el-menu-item>
                        <el-menu-item index="/sxz/errand-order">代取订单</el-menu-item>
                        <el-menu-item index="/sxz/errand-refund-apply">代取退款审核</el-menu-item>
                        <el-menu-item index="/sxz/errand-accept">代取接单任务</el-menu-item>
                        <el-menu-item index="/sxz/errand-deliver-proof">送达凭证留档</el-menu-item>
                        <el-menu-item index="/sxz/campus-auth">校园认证审核</el-menu-item>
                        <el-menu-item index="/sxz/withdraw-apply">提现审核</el-menu-item>
                        <el-menu-item index="/sxz/subscribe-message-log">订阅消息日志</el-menu-item>
                    </el-menu-item-group>
                </el-sub-menu>
                <el-sub-menu index="2">
                    <template #title>
                        <el-icon><location /></el-icon>
                        <span>设置</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/">工具箱首页</el-menu-item>
                        <el-menu-item index="logout" @click="out">退出登录</el-menu-item>
                    </el-menu-item-group>
                </el-sub-menu>
            </el-menu>
        </div>
        <div class="xuanxiangka">
            <div style="width: 100%">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SxzIndexView",
    methods: {
        out() {
            sessionStorage.removeItem("usercode");
            sessionStorage.removeItem("role");
            sessionStorage.setItem("s", false);
            this.$router.replace("/login");
        },
    },
};
</script>

